/**
 * The browser-environment fields the feedback endpoint requires. Client-only:
 * call from event handlers, never during SSR.
 */
export default function getBrowserInformation() {
  return {
    screenResolution: `${window.screen.width} x ${window.screen.height}`,
    viewportSize: `${window.outerWidth} x ${window.outerHeight}`,
    referer: window.location.href,
    userAgent: window.navigator.userAgent
  };
}
